module.exports = __webpack_public_path__ + "static/2.1GrabObject-0638ba79196c2aa1fbaa58755fcf9da4.gif";